import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesFolderOpen: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.472 3.045h-1.52v-1.52h-1.52v-1.53H6.092v12.2h-4.57v1.52h7.62v-1.52h-1.52V1.525h16.76v6.09h6.09v15.24h-1.52v3.05h1.52v4.57h1.53v-25.9h-1.53zm-22.85 27.43h22.85v1.52H7.622Z\"/><path fill=\"currentColor\" d=\"M27.432 19.805h1.52v3.05h-1.52Zm-1.53-3.04h1.53v3.04h-1.53Zm-15.23-1.53h15.23v1.53h-15.23Zm9.14-7.62h1.52v1.53h-1.52Zm-4.57 3.05h4.57v1.53h-4.57Zm-1.53-3.05h1.53v1.53h-1.53Zm-4.57 6.1h1.53v1.52h-1.53Zm-3.05 13.71h1.53v3.05h-1.53Zm-1.52-3.04h1.52v3.04h-1.52Zm-1.52-3.05h1.52v3.05h-1.52Zm-1.53-3.05h1.53v3.05h-1.53Zm-1.52-4.57h1.52v4.57H.002Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesFolderOpen
